export default __webpack_public_path__ + "d868243798cd29f06047ab7af7a739e6.svg";